const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
const uploadPreset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

export async function uploadFigureImagesToCloudinary(files) {
  if (!cloudName || !uploadPreset) {
    throw new Error('Cloudinary upload is not configured. Set the Cloudinary cloud name and upload preset.');
  }

  return Promise.all(files.map(async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', uploadPreset);

    const response = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error('Cloudinary upload failed.');
    }

    const data = await response.json();
    return data.secure_url;
  }));
}
